import type React from "react";
import style from "../SvgAnnotation.module.scss";

interface AnnotationPopoverProps {
	selectedPart: string | null;
	clickedItem: { x: number | null; y: number | null };
	svgViewBox: { width: number; height: number };
	popupOpen: boolean;
	svgIds: string[];
	annotationsMap: { [key: string]: { word: string; x: number; y: number } };
	handleWordSelect: (word: string) => void;
	closePopup?: () => void;
}

export const AnnotationPopover: React.FC<AnnotationPopoverProps> = ({
	selectedPart,
	clickedItem,
	svgViewBox,
	popupOpen,
	svgIds,
	annotationsMap,
	handleWordSelect,
}) => {
	if (!selectedPart || clickedItem.x === null || clickedItem.y === null)
		return null;

	return (
		<div
			className={style.annotationPopupContainer}
			onClick={(event) => event.stopPropagation()}
			onKeyDown={(event) => {
				if (event.key === "Enter") {
					// Handle the Enter key press
				}
			}}
			style={{
				position: "absolute",
				display: popupOpen ? "flex" : "none",
				top: `${(clickedItem.y / svgViewBox.height) * 100}%`,
				left: `${(clickedItem.x / svgViewBox.width) * 100}%`,
				transform: "translate(-50%, -100%)",
				zIndex: 1000,
			}}
		>
			<p>Select a word:</p>
			<ul>
				{svgIds
					.filter(
						(id) =>
							!Object.values(annotationsMap)
								.map((item) => item.word)
								.includes(id),
					)
					.map((id) => (
						<li
							key={id}
							onClick={() => handleWordSelect(id)}
							onKeyUp={(event) => {
								if (event.key === "Enter") {
									handleWordSelect(id);
								}
							}}
						>
							{id}
						</li>
					))}
			</ul>
		</div>
	);
};
